var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#FDF7E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15247_42574",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15247_42574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5001 16.5053H8.91672C8.58339 16.5053 8.33686 16.356 8.17714 16.0574C8.01742 15.7588 8.03478 15.4706 8.22922 15.1928L14.4584 6.23449C14.5973 6.04004 14.7778 5.90463 15.0001 5.82824C15.2223 5.75185 15.4514 5.75532 15.6876 5.83865C15.9237 5.92199 16.0973 6.06782 16.2084 6.27615C16.3195 6.48449 16.3612 6.70671 16.3334 6.94282L15.6667 12.3387H18.8959C19.257 12.3387 19.5105 12.4984 19.6563 12.8178C19.8021 13.1373 19.757 13.4359 19.5209 13.7137L12.6667 21.922C12.5139 22.1025 12.3264 22.2206 12.1042 22.2762C11.882 22.3317 11.6667 22.3109 11.4584 22.2137C11.2501 22.1164 11.0869 21.9671 10.9688 21.7657C10.8508 21.5643 10.8056 21.3456 10.8334 21.1095L11.5001 16.5053Z",
    fill: "#EEAE18"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpark);
export default __webpack_public_path__ + "static/media/spark.f20ebbe13397617895aa0eeace927913.svg";
export { ForwardRef as ReactComponent };